import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import EventRegistration from '../views/EventRegistration.vue'
import EnterConfirmationCode from '../views/EnterConfirmationCode.vue'

// const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   }
// ]

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/eventregistration',
    name: 'EventRegistration',
    component: EventRegistration
  },
  {
    path: '/bycode/:code?',
    name: 'EnterConfirmationCode',
    component: EnterConfirmationCode,
    props: true,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router